/***
*
*   BILLING / PLAN
*   Update the billing plan
*
**********/

import React, { useContext } from 'react';
import { AuthContext, Card, Form, Message, Grid, usePlans, InAppPricing } from 'components/lib';

export function BillingPlan(props){

  const plans = usePlans();
  const context = useContext(AuthContext);

  return (
    <>
    {/* <Grid cols={2}> */}
    <Card loading={ plans.loading || props.subscription.loading } restrictWidth className={ props.className }>

      { props.subscription?.data?.object && 
        <Message 
          type='info'
          title='Your Billing Cycle'
          text={ `${props.subscription.data.object.current_period_start} to ${props.subscription.data.object.current_period_end}` }
        />
      }

      <Form
        data={{
          plan: {
            label: 'Your subscription plan',
            type: 'select',
            required: true,
            default: plans?.data?.active,
            options: plans?.data?.list
          },
          tax: {
            text: '* Plus applicable taxes',
            type: 'label'
          }
        }}
        url='/api/account/plan'
        method='PATCH'
        buttonText='Update Plan'
        callback={(res) => {

          context.update({ plan: res.data.data.plan });

        }}
      />
  </Card>
  {/* <InAppPricing/> */}
  {/* </Grid> */}
  </>
  )
} 